import { BusinessDownloadConfig } from '../types';
import { ECHARTS_DATASOURCE_METRICS_PC_DETAILS } from '@/pages/intelligence/utils/constant';
import { DETAILS_STATS_COUNTRIES_COMMON_DOWNLOAD_API, publisherCheckboxList } from './common';

const pcDetailsConfig: BusinessDownloadConfig = {
  'pc-stats-countries': {
    apiUrl: DETAILS_STATS_COUNTRIES_COMMON_DOWNLOAD_API,
    bubbleText: '',
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'cascadeMetricSelector',
        field: 'metrics',
        defaultValue: [['All', 'All']],
        // defaultValue: DATASOURCE_METRICS_VALUE_PC_DETAILS,
        cascadeOptions: ECHARTS_DATASOURCE_METRICS_PC_DETAILS,
        ifUseMetricsMap: true,
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
        ],
      },
    ],
  },
  'pc-stats-countries-pcu': {
    apiUrl: DETAILS_STATS_COUNTRIES_COMMON_DOWNLOAD_API,
    bubbleText: '',
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'cascadeMetricSelector',
        field: 'metrics',
        defaultValue: [['All', 'All']],
        // defaultValue: DATASOURCE_METRICS_VALUE_PC_DETAILS,
        cascadeOptions: ECHARTS_DATASOURCE_METRICS_PC_DETAILS,
        ifUseMetricsMap: true,
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
        ],
      },
    ],
  },
  'pc-details-store-rank': {
    apiUrl: '/api/v1/intelligence_pc/detail/stats/metrics/store_rank/pcStoreRankDetailExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_chart',
        type: 'checkboxGroup',
        field: 'source',
        defaultValue: ['steam'],
        options: [
          { label: 'Steam', value: 'steam' },
          { label: 'Epic', value: 'epic' },
        ],
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation_change',
        type: 'switch',
        defaultValue: true,
        field: 'ratio_show',
      },
    ],
  },
};

export default pcDetailsConfig;
